import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { useNavigate } from "react-router-dom";
import {
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Link,
  Modal,
  Typography,
  useTheme,
} from "@mui/material";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { useConfirm } from "material-ui-confirm";

import moment from "moment";
import "moment-timezone";

import ListResponsive from "../../components/other/ListResponsive";
import {
  handlePaging,
  handlePagingAll,
} from "../../components/api/APIUtilities";
import { postNotification } from "../../components/utilities/Notifications";
import { ticketPlatformSearch } from "./utils/ticket";
import {
  BCPArrowLeft,
  BCPArrowUpArrowDown,
  BCPCalendarDay,
  BCPCircleArrowDown,
  BCPCircleArrowUp,
  BCPDollarCircle,
  BCPFilter,
  BCPSquarePlus,
  BCPXmark,
} from "../../components/icons/bcp/BCPIcons";
import {
  useProcessing,
  useSignout,
} from "../../components/user/BCPAuthReducers";
import { signout } from "../../components/user/BCPAuth";
import {
  deleteData,
  getCurrencyAmount,
  getData,
  postData,
} from "../../components/utilities/UtilityFunctions";
import DateRangePickerComponent from "../../components/utilities/DateRangePickerComponent";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import {
  clearFilterSx,
  filterAndSortTicketSales,
  getFilterSx,
  updateFilters,
} from "../../components/utilities/SortFilterFunctions";
import OptionsMenu from "../../components/layout/OptionsMenu";
import InfoContainer from "../../components/layout/InfoContainer";
import { stringToUrl } from "../events/utils/event";
const IS_BCP = getEnvironmentVariable("IS_BCP") === "true";

export default function TicketSales() {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const theme = useTheme();

  const [nextKey, setNextKey] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const [periodRange1, setPeriodRange1] = useState([
    moment().startOf("month"),
    moment(),
  ]);
  const [periodRange2, setPeriodRange2] = useState([
    moment().subtract(1, "month").startOf("month"),
    moment().subtract(1, "month").endOf("month"),
  ]);

  const [filteredTickets, setFilteredTickets] = useState(null);
  const [filteredEventTickets, setFilteredEventTickets] = useState(null);

  const [filters, setFilters] = useState([]);
  const [currentEvent, setCurrentEvent] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [anchorEl3, setAnchorEl3] = useState(null);

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [tickets, setTickets] = useState(null);
  const [feesummary, setFeesummary] = useState(null);
  const [ticketData, setTicketData] = useState(null);
  const handleTicketRefundData = (_ticket) => {
    if (_ticket?.refunds?.length > 0) {
      let refunded = 0;
      for (let refund of _ticket.refunds) {
        refunded += refund.amount;
      }
      _ticket.status =
        _ticket.amount === refunded ? "Refunded" : "Partially Refunded";
    }
    return _ticket;
  };
  const updateTickets = (_ticket) => {
    _ticket = handleTicketRefundData(_ticket);
    let _tickets = [];
    for (let i = 0; i < tickets.length; i++) {
      if (tickets[i].id === _ticket.id) {
        _tickets.push({ ...tickets[i], ..._ticket });
      } else {
        _tickets.push(tickets[i]);
      }
    }

    setTickets(_tickets);
    hanleFeesummaryComparison();
  };

  const useSignoutReducer = useSignout();
  const useProcessingReducer = useProcessing();

  const fetchTransactions = async (freshSearch) => {
    let limit = 100;
    var data = await handlePaging(
      "/transactions",
      {
        sortAscending: false,
        limit: limit,
        ownerId: authContext?.authState?.identity?.userId,
        "expand[]": ["event"],
      },
      nextKey,
      setNextKey
    );

    if (data.length !== limit) {
      setHasMore(false);
      if (!data?.length) {
        postNotification(
          "info",
          "No transactions found matching your search criteria."
        );
        return;
      }
    }

    let _tickets =
      !freshSearch && tickets?.length ? [...tickets, ...data] : data;

    _tickets = _tickets.map((ticket) => {
      return handleTicketRefundData(ticket);
    });

    setTickets(_tickets);
  };

  const fetchFeesummary = async (_startDate, _endDate) => {
    var returnData;
    var queryStringParameters = {};
    if (_startDate) {
      queryStringParameters.startDate = _startDate.format();
    }
    if (_endDate) {
      queryStringParameters.endDate = _endDate.format();
    }
    try {
      returnData = await getData("/transactions/feesummary", {
        queryStringParameters: queryStringParameters,
      });
    } catch (err) {
      console.error(err);
    }

    return returnData;
  };

  const fetchUser = async (userId) => {
    if (user) {
      return user;
    }
    var returnObj;
    try {
      returnObj = await getData(`/users/${userId}`, {
        queryStringParameters: {
          "expand[]": ["bankAccount"],
        },
      });
    } catch (err) {
      console.error(err);
    }
    return returnObj;
  };

  const fetchEvents = async () => {
    try {
      const apiEvents = await handlePagingAll(`/events`, {
        limit: 100,
        ownerId: authContext?.authState?.identity?.userId,
        sortAscending: false,
        toEvents: true,
        ticketPrice: 1,
      });

      if (apiEvents) {
        setEvents(apiEvents);
      }
    } catch (err) {
      postNotification("error", err);
    }
  };

  const fetchTicketsByEvent = async (eventId) => {
    try {
      setLoading(true);

      const apiTickets = await getData(`/transactions`, {
        limit: 100,
        eventId: eventId,
        sortAscending: false,
        "expand[]": ["event"],
      });

      if (apiTickets?.data && apiTickets?.data?.length) {
        return apiTickets?.data;
      } else {
        postNotification("info", "No transactions found for selected event.");
        updateFilters("ticket-event-all", false, filters, setFilters);
        return [];
      }
    } catch (err) {
      setFilteredTickets(null);
      updateFilters("ticket-event-all", false, filters, setFilters);
    } finally {
      setLoading(false);
    }
  };

  async function parallelFeesummaryComparison() {
    const taskUser = fetchUser(authContext?.authState?.identity?.userId);

    let periodType = "month";
    let momentStart1 = periodRange1?.[0] || moment().startOf(periodType);
    let momentEnd1 = periodRange1?.[1] || moment().endOf(periodType);
    let momentStart2 =
      periodRange2?.[0] || moment().subtract(1, periodType).startOf(periodType);
    let momentEnd2 =
      periodRange2?.[1] || moment().subtract(1, periodType).endOf(periodType);
    const task1 = fetchFeesummary(momentStart1, momentEnd1);
    const task2 = fetchFeesummary(momentStart2, momentEnd2);

    return {
      user: await taskUser,

      period1: await task1,
      period2: await task2,
    };
  }

  async function hanleFeesummaryComparison() {
    setFeesummary(null);
    var _feeSummary = await parallelFeesummaryComparison();
    if (_feeSummary?.user) {
      setUser(_feeSummary?.user);
      setCurrency(_feeSummary?.user?.bankAccount?.availableCurrencies?.[0]);
      delete _feeSummary.user;
    }
    setFeesummary(_feeSummary);
  }

  useEffect(() => {
    const check = async () => {
      try {
        if (!authContext?.authState?.identity?.userId) {
          navigate(`/login?redirect_url=${stringToUrl(window.location.href)}`);
          return;
        }

        await hanleFeesummaryComparison();
        await fetchTransactions();
        await fetchEvents();
      } catch (err) {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          try {
            if (IS_BCP) {
              navigate("/logout");
            } else {
              await signout(useSignoutReducer, {
                setProcessing: useProcessingReducer,
                navigate: navigate,
              });
            }
          } catch (err) {
            postNotification("error", err);
          }
          navigate(`/login?redirect_url=${stringToUrl(window.location.href)}`);
          return;
        } else {
          postNotification("error", err);
        }
      } finally {
        setLoading(false);
      }
    };
    check();
    // eslint-disable-next-line
  }, []);

  // Grabs event specific tickets when event filter is selected
  useEffect(() => {
    if (filters?.length && tickets?.length) {
      const eventFilter = [
        ...filters.filter((item) => item.includes("ticket-event")),
      ]?.[0];
      const eventId = eventFilter?.split("-")[2] || currentEvent;

      if (eventFilter && currentEvent !== eventId) {
        const go = async () => {
          try {
            const apiData = await fetchTicketsByEvent(eventId);

            if (apiData?.length) {
              setFilteredEventTickets(apiData);
              setCurrentEvent(eventId);
            }
          } catch (err) {
            postNotification("error", err);
            setFilteredEventTickets(null);
            setCurrentEvent(null);
          }
        };

        if (eventFilter === "ticket-event-all") {
          setFilteredEventTickets(null);
          setCurrentEvent(null);
        } else {
          go();
        }
      }
    }

    // eslint-disable-next-line
  }, [filters, tickets]);

  useEffect(() => {
    const go = async () => {
      if (tickets?.length && filters?.length) {
        const tempTickets = filterAndSortTicketSales(
          filteredEventTickets ? filteredEventTickets : tickets,
          filters
        );

        setFilteredTickets(tempTickets);
      } else {
        setFilteredTickets(null);
      }
    };

    go();
    // eslint-disable-next-line
  }, [tickets, filters, filteredEventTickets]);

  return (
    <Box sx={{ width: "100%" }}>
      <Container
        sx={{
          pt: 2,
          pb: 2,
        }}
        maxWidth="lg"
      >
        <Grid
          container
          sx={{
            spacing: 2,
            p: 2,
            alignItems: "end",
          }}
        >
          <Grid item xs={12} sx={{ mb: 2 }}>
            <Link
              href="/organize/dashboard"
              color="link.main"
              sx={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <BCPArrowLeft
                sx={{ "padding-right": "1rem", "padding-bottom": "2px" }}
              />{" "}
              Back to Host Dashboard
            </Link>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h2"
              component="h3"
              fontWeight="700"
              gutterBottom
            >
              Ticket Sales Summary
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              p: 2,
            }}
          >
            <Typography paragraph>Period</Typography>
            <DateRangePickerComponent
              labelStart="Start"
              labelEnd="End"
              value={periodRange1}
              setValue={setPeriodRange1}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              p: 2,
            }}
          >
            <Typography paragraph>vs</Typography>
            <DateRangePickerComponent
              labelStart="Start"
              labelEnd="End"
              value={periodRange2}
              setValue={setPeriodRange2}
            />
          </Grid>
          <Grid item xs={12} md={2} sx={{ p: 2 }}>
            <Button
              fullWidth
              color="primary"
              variant="outlined"
              onClick={hanleFeesummaryComparison}
            >
              APPLY
            </Button>
          </Grid>
          {[
            { label: "Gross", type: "gross" },
            { label: "Fees", type: "fees" },
            { label: "Net", type: "net" },
          ].map((feesummaryBoxData, index) => (
            <Grid
              key={index}
              item
              xs={12}
              md={4}
              sx={{
                p: 2,
              }}
            >
              <FeesummaryBox
                {...feesummaryBoxData}
                feesummary={feesummary}
                currency={currency}
              />
            </Grid>
          ))}

          {[
            { label: "Refunds", type: "refunds" },
            { label: "Refunded Fees", type: "refundedFees" },
          ].map((feesummaryBoxData, index) => (
            <Grid
              key={index}
              item
              xs={12}
              md={6}
              sx={{
                p: 2,
              }}
            >
              <FeesummaryBox
                {...feesummaryBoxData}
                feesummary={feesummary}
                currency={currency}
              />
            </Grid>
          ))}
        </Grid>
        <Grid container sx={{ gap: 2, p: 2 }}>
          <Grid item xs={12} md={9}>
            <Typography
              variant="h2"
              component="h3"
              fontWeight="700"
              gutterBottom
            >
              My Ticket Sales
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ListResponsive
              originalList={
                loading
                  ? null
                  : filteredTickets
                    ? filteredTickets
                    : tickets?.length
                      ? tickets
                      : []
              }
              doSearch
              loadMore={fetchTransactions}
              hasMore={hasMore}
              scrollToTop
              searchProps={{
                label: "Search Tickets",
                performSearch: ticketPlatformSearch,
              }}
              actionButtonBottom={[
                {
                  label: "Sort",
                  startIcon: <BCPArrowUpArrowDown />,
                  onClick: (e) => {
                    setAnchorEl(e.currentTarget);
                  },
                  disabled: loading || !tickets?.length,
                  sx: {
                    ...getFilterSx(
                      Boolean(
                        filters.length &&
                          filters.some((item) => item.includes("sort"))
                      ),
                      filters,
                      theme
                    ),
                  },
                },
                {
                  label: "Filters",
                  startIcon: <BCPFilter />,
                  disabled: loading || !tickets?.length,
                  "aria-expanded": Boolean(anchorEl3) ? true : undefined,
                  onClick: (e) => {
                    setAnchorEl2(e.currentTarget);
                  },
                  sx: {
                    ...getFilterSx(
                      Boolean(
                        filters.length &&
                          filters.some((item) => item.includes("filter"))
                      ),
                      filters,
                      theme
                    ),
                  },
                },
                {
                  label: "Event",
                  startIcon: <BCPCalendarDay />,
                  disabled: loading || !tickets?.length,
                  "aria-expanded": Boolean(anchorEl3) ? true : undefined,
                  onClick: (e) => {
                    setAnchorEl3(e.currentTarget);
                  },
                  sx: {
                    ...getFilterSx(
                      Boolean(
                        filters.length &&
                          filters.some(
                            (item) =>
                              item.includes("ticket-event") &&
                              !item.includes("ticket-event-all")
                          )
                      ),
                      filters,
                      theme
                    ),
                  },
                },
                {
                  label: "Clear Filters",
                  startIcon: <BCPXmark />,
                  disabled: loading || !tickets?.length,
                  sx: {
                    ...clearFilterSx(
                      filters?.length &&
                        filters?.some(
                          (item) => !item.includes("ticket-event-all")
                        ),
                      filters,
                      theme
                    ),
                  },
                  onClick: () => {
                    setFilters([]);
                    setFilteredTickets(null);
                    setAnchorEl(null);
                    setAnchorEl2(null);
                    setAnchorEl3(null);
                  },
                },
              ]}
              rowProps={{
                mapFunction: (row, index) => (
                  <Grid
                    key={`${row.id || index}-${row.updated_at}`}
                    item
                    xs={12}
                    onClick={(e) => {
                      setTicketData(row);
                    }}
                    sx={{
                      p: 1,
                      mb: 1,
                      border: "1px solid rgba(0, 0, 0, 0.12)",
                      borderRadius: 1,
                      boxShadow: 1,
                      "&:hover": {
                        cursor: "pointer",
                      },
                    }}
                  >
                    <Grid container>
                      <Grid item xs={12} sm={8} lg={9}>
                        <Typography variant="body1">
                          Player: {row.playerName}
                        </Typography>

                        <Typography variant="caption" paragraph sx={{ mb: 0 }}>
                          Event: {row.event?.name}
                        </Typography>

                        <Typography variant="caption" paragraph sx={{ mb: 0 }}>
                          Order Id: {row.orderId}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={4}
                        lg={3}
                        sx={{ textAlign: "right" }}
                      >
                        <Typography variant="body1">
                          {`${row.currency?.toUpperCase()} ${(
                            (row.amount - (row.refunded || 0)) /
                            100
                          ).toFixed(2)}`}
                        </Typography>

                        {/* completed, no charge, pending charge, refunded, expired checkout*/}
                        <Chip
                          label={row?.status?.toUpperCase()}
                          size="small"
                          sx={{ width: "100%" }}
                          color={
                            row?.status?.toLowerCase() === "completed charge" ||
                            row?.status?.toLowerCase() === "no charge"
                              ? "success"
                              : row?.status?.toLowerCase() ===
                                    "pending charge" ||
                                  row?.status?.toLowerCase() ===
                                    "waiting for charge"
                                ? "warning"
                                : "error"
                          }
                        />
                        <Typography variant="caption" paragraph sx={{ mb: 0 }}>
                          Transaction Date:{" "}
                          {moment(row.created_at).format("L - LT")}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ),
              }}
            >
              {!loading && !tickets?.length && (
                <InfoContainer
                  title="No tickets found"
                  body={
                    "You have no tickets at the moment. Create an event with ticketing to get started!"
                  }
                  ActionButton={
                    <Button
                      variant="contained"
                      href={"/organize/event"}
                      startIcon={<BCPSquarePlus />}
                    >
                      Create Event
                    </Button>
                  }
                  sx={{ mt: 1 }}
                />
              )}
            </ListResponsive>
          </Grid>
        </Grid>
      </Container>

      <TicketModal
        ticketData={ticketData}
        setTicketData={setTicketData}
        updateTickets={updateTickets}
        authContext={authContext}
      />

      {/* Sorting */}
      <OptionsMenu
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        items={[
          {
            name: "sort-date-asc",
            label: "Date Ascending",
            selected: filters.includes("sort-date-asc"),
            onClick: () =>
              updateFilters("sort-date-asc", false, filters, setFilters),
          },
          {
            name: "sort-date-desc",
            label: "Date Descending",
            selected: filters.includes("sort-date-desc"),
            onClick: () =>
              updateFilters("sort-date-desc", false, filters, setFilters),
          },
          {
            name: "sort-price-asc",
            label: "Price Ascending",
            selected: filters.includes("sort-price-asc"),
            onClick: () =>
              updateFilters("sort-price-asc", false, filters, setFilters),
          },
          {
            name: "sort-price-desc",
            label: "Price Descending",
            selected: filters.includes("sort-price-desc"),
            onClick: () =>
              updateFilters("sort-price-desc", false, filters, setFilters),
          },
          {
            name: "sort-player-name-asc",
            label: "Player Name Ascending",
            selected: filters.includes("sort-player-name-asc"),
            onClick: () =>
              updateFilters("sort-player-name-asc", false, filters, setFilters),
          },
          {
            name: "sort-player-name-desc",
            label: "Player Name Descending",
            selected: filters.includes("sort-player-name-desc"),
            onClick: () =>
              updateFilters(
                "sort-player-name-desc",
                false,
                filters,
                setFilters
              ),
          },
          {
            name: "sort-event-name-asc",
            label: "Event Name Ascending",
            selected: filters.includes("sort-event-name-asc"),
            onClick: () =>
              updateFilters("sort-event-name-asc", false, filters, setFilters),
          },
          {
            name: "sort-event-name-desc",
            label: "Event Name Descending",
            selected: filters.includes("sort-event-name-desc"),
            onClick: () =>
              updateFilters("sort-event-name-desc", false, filters, setFilters),
          },
        ]}
        name="tickets-sort-menu"
      />

      {/* Filters */}
      <OptionsMenu
        anchorEl={anchorEl2}
        setAnchorEl={setAnchorEl2}
        items={[
          {
            name: "filter-completed",
            label: "Completed Charge",
            selected: filters.includes("filter-completed"),
            onClick: () =>
              updateFilters("filter-completed", false, filters, setFilters),
          },
          {
            name: "filter-pending",
            label: "Pending Charge",
            selected: filters.includes("filter-pending"),
            onClick: () =>
              updateFilters("filter-pending", false, filters, setFilters),
          },
          {
            name: "filter-expired",
            label: "Expired Checkout",
            selected: filters.includes("filter-expired"),
            onClick: () =>
              updateFilters("filter-expired", false, filters, setFilters),
          },
          {
            name: "filter-refunded",
            label: "Refunded",
            selected: filters.includes("filter-refunded"),
            onClick: () =>
              updateFilters("filter-refunded", false, filters, setFilters),
          },
        ]}
        name="tickets-filter-menu"
      />

      {/* Filter by Event */}
      {events?.length ? (
        <OptionsMenu
          anchorEl={anchorEl3}
          setAnchorEl={setAnchorEl3}
          items={[
            {
              name: "ticket-event-all",
              label: "All Tickets",
              selected:
                !filters.some((item) => item.includes("ticket-event-")) ||
                filters.some((item) => item.includes("ticket-event-all")),
              onClick: () =>
                updateFilters("ticket-event-all", false, filters, setFilters),
            },
            { divider: true },
            ...events.map((event) => ({
              name: `ticket-event-${event.id}`,
              label: event.name,
              selected: filters.includes(`ticket-event-${event.id}`),
              onClick: () =>
                updateFilters(
                  `ticket-event-${event.id}`,
                  false,
                  filters,
                  setFilters
                ),
            })),
          ]}
          name="tickets-event-menu"
        />
      ) : (
        <></>
      )}
    </Box>
  );
}

function TicketModal(props) {
  const { ticketData, setTicketData, updateTickets } = props;
  const [loading, setLoading] = useState(false);

  const confirm = useConfirm();

  return (
    <>
      <Modal
        disableAutoFocus
        open={Boolean(ticketData)}
        onClose={() => {
          setTicketData(null);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={{ zIndex: 990 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            maxHeight: "95vh",
            overflowY: "scroll",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4,
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setTicketData(null);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid
            container
            spacing={1}
            sx={{
              pb: 1,
              mb: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Grid item xs={12}>
              <Typography variant="h4" gutterBottom>
                {ticketData?.event?.name}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12}>
              <Typography variant="h5" gutterBottom>
                {ticketData?.playerName}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body1" gutterBottom>
                Order Id
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography variant="body1" gutterBottom>
                {ticketData?.orderId}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body1" gutterBottom>
                Purchase Date
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography variant="body1" gutterBottom>
                {ticketData?.created_at
                  ? moment(ticketData.created_at).format("LL - LT")
                  : ""}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body1" gutterBottom>
                Gross Amount
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography variant="body1" gutterBottom>
                ${ticketData?.amount ? (ticketData.amount / 100).toFixed(2) : 0}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body1" gutterBottom>
                Fee Total
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography variant="body1" gutterBottom>
                ${ticketData?.fee ? (ticketData.fee / 100).toFixed(2) : 0}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body1" gutterBottom>
                Net Amount
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography variant="body1" gutterBottom>
                $
                {ticketData?.amount
                  ? (
                      (ticketData.fee
                        ? ticketData.amount - ticketData.fee
                        : ticketData.amount) / 100
                    ).toFixed(2)
                  : 0}
              </Typography>
            </Grid>

            {ticketData?.refunds?.length > 0 &&
              ticketData.refunds.map((refund) => (
                <>
                  <Grid item xs={6}>
                    <Typography variant="body1" gutterBottom>
                      Refund Date
                    </Typography>
                  </Grid>
                  <Grid item xs={6} textAlign="right">
                    <Typography variant="body1" gutterBottom>
                      {refund?.refundDate
                        ? moment(refund.refundDate).format("MMMM DD, YYYY - LT")
                        : ""}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body1" gutterBottom>
                      Refunded Amount
                    </Typography>
                  </Grid>
                  <Grid item xs={6} textAlign="right">
                    <Typography variant="body1" gutterBottom>
                      ${refund?.amount ? (refund.amount / 100).toFixed(2) : 0}
                    </Typography>
                  </Grid>
                </>
              ))}

            <Grid item xs={6}>
              <Typography variant="body1" gutterBottom>
                Status
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              {ticketData?.status && (
                <Typography
                  sx={{
                    color:
                      ticketData.status.toLowerCase() === "completed charge" ||
                      ticketData.status.toLowerCase() === "no charge"
                        ? "success.main"
                        : ticketData.status.toLowerCase() ===
                              "pending charge" ||
                            ticketData.status.toLowerCase() ===
                              "waiting for charge"
                          ? "warning.main"
                          : "error.main",
                  }}
                >
                  {ticketData.status}
                </Typography>
              )}
            </Grid>

            {ticketData?.status?.toLowerCase() === "completed charge" && (
              <>
                <Grid item xs={6}>
                  <Button
                    color="error"
                    fullWidth
                    variant="outlined"
                    onClick={async (e) => {
                      if (ticketData?.chargeType === "square") {
                        postNotification(
                          "error",
                          "Square transactions cannot be refunded through this interface. Please log into your Square Dashboard to refund this transaction."
                        );
                        return;
                      }

                      try {
                        await confirm({
                          title: `Refund User.`,
                          description:
                            "Would you like to refund the ticket for this player?",
                          confirmationText: "Yes",
                          cancellationText: "No",
                          dialogProps: {
                            sx: {
                              zIndex: 99999,
                            },
                          },
                        });
                      } catch (err) {
                        return;
                      }

                      try {
                        await confirm({
                          title: `Are you sure?`,
                          description:
                            "Are you sure you would like to refund the ticket for this player? This action cannot be undone.",
                          confirmationText: "Yes",
                          cancellationText: "No",
                          dialogProps: {
                            sx: {
                              zIndex: 99999,
                            },
                          },
                        });
                      } catch (err) {
                        return;
                      }

                      try {
                        setLoading(true);
                        const refundTransaction = await postData(
                          `/transactions/${ticketData.id}/refundTransaction`
                        );
                        updateTickets(refundTransaction);
                        postNotification("success", "Transaction refunded");
                      } catch (err) {
                        setLoading(false);
                        postNotification("error", err);
                        return;
                      }

                      if (ticketData.teamPlayerId) {
                        let drop = false;
                        let remove = false;
                        try {
                          await confirm({
                            title: `Drop Team`,
                            description: "Would you like to drop this team?",
                            confirmationText: "Yes",
                            cancellationText: "No",
                            dialogProps: {
                              sx: {
                                zIndex: 99999,
                              },
                            },
                          });

                          await confirm({
                            title: `Drop Team`,
                            description:
                              "Are you sure you would you like to drop this team?",
                            confirmationText: "Yes",
                            cancellationText: "No",
                            dialogProps: {
                              sx: {
                                zIndex: 99999,
                              },
                            },
                          });

                          drop = true;

                          try {
                            await confirm({
                              title: `Remove Team`,
                              description:
                                "Would you like to remove this team entirely from the roster?",
                              confirmationText: "Yes",
                              cancellationText: "No",
                              dialogProps: {
                                sx: {
                                  zIndex: 99999,
                                },
                              },
                            });

                            await confirm({
                              title: `Remove Team`,
                              description:
                                "Are you sure you would you like to remove this team from the roster? This cannot be undone.",
                              confirmationText: "Yes",
                              cancellationText: "No",
                              dialogProps: {
                                sx: {
                                  zIndex: 99999,
                                },
                              },
                            });

                            remove = true;
                          } catch (err) {}
                        } catch (err) {}

                        try {
                          if (remove) {
                            await deleteData(
                              `/teamplayers/${ticketData.teamPlayerId}`
                            );
                          } else if (drop) {
                            await postData(
                              `/teamplayers/${ticketData.teamPlayerId}`,
                              {
                                body: {
                                  set: {
                                    dropped: true,
                                  },
                                },
                              }
                            );
                          }
                        } catch (err) {
                          setLoading(false);
                          postNotification("error", err);
                          return;
                        }
                      } else if (ticketData.playerId) {
                        let drop = false;
                        let remove = false;
                        try {
                          await confirm({
                            title: `Drop Player`,
                            description: "Would you like to drop this player?",
                            confirmationText: "Yes",
                            cancellationText: "No",
                            dialogProps: {
                              sx: {
                                zIndex: 99999,
                              },
                            },
                          });

                          await confirm({
                            title: `Drop Player`,
                            description:
                              "Are you sure you would you like to drop this player?",
                            confirmationText: "Yes",
                            cancellationText: "No",
                            dialogProps: {
                              sx: {
                                zIndex: 99999,
                              },
                            },
                          });

                          drop = true;

                          try {
                            await confirm({
                              title: `Remove Player`,
                              description:
                                "Would you like to remove this player entirely from the roster?",
                              confirmationText: "Yes",
                              cancellationText: "No",
                              dialogProps: {
                                sx: {
                                  zIndex: 99999,
                                },
                              },
                            });

                            await confirm({
                              title: `Remove Player`,
                              description:
                                "Are you sure you would you like to remove this player from the roster? This cannot be undone.",
                              confirmationText: "Yes",
                              cancellationText: "No",
                              dialogProps: {
                                sx: {
                                  zIndex: 99999,
                                },
                              },
                            });

                            remove = true;
                          } catch (err) {}
                        } catch (err) {}

                        try {
                          if (remove) {
                            await deleteData(`/players/${ticketData.playerId}`);
                          } else if (drop) {
                            await postData(`/players/${ticketData.playerId}`, {
                              body: {
                                set: {
                                  dropped: true,
                                },
                              },
                            });
                          }
                        } catch (err) {
                          setLoading(false);
                          postNotification("error", err);
                          return;
                        }
                      }

                      setLoading(false);
                      setTicketData(null);
                    }}
                  >
                    Issue Refund
                  </Button>
                </Grid>

                <Grid item xs={6}>
                  <Button
                    color="success"
                    fullWidth
                    variant="contained"
                    onClick={async (e) => {
                      setLoading(true);
                      try {
                        await postData(
                          `/transactions/${ticketData.id}/sendReceipt`
                        );
                        postNotification("success", "Receipt sent");
                        setLoading(false);
                      } catch (err) {
                        setLoading(false);
                        postNotification("error", err);
                        return;
                      }
                      setTicketData(null);
                    }}
                  >
                    Resend Receipt
                  </Button>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </Modal>
      {loading && <ModalLoadingFull />}
    </>
  );
}

function FeesummaryBox({ currency, feesummary, label, type }) {
  const trend = !(feesummary?.period2?.[type] || 0)
    ? "N/A"
    : (
        ((feesummary?.period1?.[type] || 0) /
          (feesummary?.period2?.[type] || 0)) *
        100
      ).toFixed(0);
  const theme = useTheme();
  return (
    <Box
      sx={{
        minHeight: "165px",
        transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        borderRadius: 1,
        border: "none rgba(224, 224, 224, 0.596)",
        backgroundColor: "primary.main",
        color: "primary.contrastText",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Box sx={{ p: 3 }}>
        <Grid container>
          <Grid item xs={12}>
            <Typography>
              <BCPDollarCircle /> {label}
            </Typography>
          </Grid>
          {!feesummary ? (
            <Grid item xs={12}>
              <CircularProgress sx={{ color: "primary.contrastText" }} />
            </Grid>
          ) : (
            <>
              <Grid item xs={12}>
                <Grid
                  container
                  sx={{
                    alignItems: "center",
                  }}
                >
                  <Grid item>
                    <Typography
                      sx={{
                        margin: "14px 8px 6px 0px",
                        lineHeight: "1.334em",
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "2.125rem",
                        fontWeight: "500",
                      }}
                    >
                      {getCurrencyAmount(
                        currency,
                        (feesummary.period1?.[type] || 0) / 100
                      )}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      sx={{
                        color:
                          trend === "N/A"
                            ? "warning.main"
                            : trend > 100
                              ? "success.main"
                              : trend < 95
                                ? "error.main"
                                : "warning.main",
                      }}
                    >
                      {trend > 100 ? (
                        <BCPCircleArrowUp />
                      ) : trend < 95 ? (
                        <BCPCircleArrowDown />
                      ) : (
                        <></>
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  <span
                    style={{
                      color:
                        trend === "N/A"
                          ? theme?.palette?.warning.main
                          : trend > 100
                            ? theme?.palette?.success.main
                            : trend < 95
                              ? theme?.palette?.error.main
                              : theme?.palette?.warning.main,
                    }}
                  >
                    {trend === "N/A" ? trend : `${trend}%`}
                  </span>{" "}
                  of{" "}
                  {getCurrencyAmount(
                    currency,
                    (feesummary.period2?.[type] || 0) / 100
                  )}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </Box>
  );
}
